module.exports = "/_next/static/images/fcd65b2f0fb7a12f056df24472c92530-rewards-illustration@3x.png";